import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, CheckCircle, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { fadeInUp, staggerContainer } from "@/lib/constants";
import { useScrollToSection } from "@/hooks/useScrollToSection";

const entregables = [
  "Análisis de tus datos de ventas, costes y márgenes",
  "Dónde estás perdiendo dinero (y cuánto)",
  "2-3 acciones concretas que puedes aplicar este mes",
  "Un plan claro si decides seguir trabajando conmigo"
];

export const OfertaSection = () => {
  const handleContactClick = useScrollToSection("contacto");

  return (
    <section className="relative section-padding bg-slate-900/50" data-testid="oferta-section">
      <div className="max-w-4xl mx-auto relative z-10">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={staggerContainer}
        >
          <motion.div variants={fadeInUp} className="text-center mb-8">
            <span className="text-indigo-400 font-medium text-sm uppercase tracking-wider">
              Así empezamos
            </span>
            <h2 className="text-3xl sm:text-4xl font-bold mt-4">
              Diagnóstico de tu negocio en <span className="text-gradient">7 días</span>
            </h2>
            <p className="text-slate-400 mt-4 max-w-2xl mx-auto text-base leading-relaxed">
              Lo primero que hago es revisar tus números y encontrar las fugas.
              Rápido, práctico y sin informes de 50 páginas. Solo lo que necesitas para actuar.
            </p>
          </motion.div>

          <motion.div variants={fadeInUp} className="glass-card rounded-2xl p-8 md:p-10">
            <div className="flex items-center gap-3 mb-6">
              <Clock className="w-6 h-6 text-indigo-400" />
              <h3 className="text-xl font-bold text-white">Qué incluye el diagnóstico</h3>
            </div>

            <div className="space-y-4 mb-8">
              {entregables.map((item, index) => (
                <div key={index} className="flex items-start gap-3">
                  <CheckCircle className="w-5 h-5 text-cyan-400 mt-0.5 flex-shrink-0" />
                  <span className="text-slate-300">{item}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-4 pt-6 border-t border-slate-700/50">
              <Button
                asChild
                className="btn-glow bg-indigo-600 hover:bg-indigo-700 text-white px-8 py-6 text-base rounded-full w-full sm:w-auto"
                data-testid="oferta-cta-btn"
              >
                <Link to="/contacto" onClick={handleContactClick}>
                  Quiero mi diagnóstico
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
              <p className="text-slate-500 text-sm">
                Gratis y sin compromiso
              </p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};
